const selectors = {
  breadcrumbLink: "breadcrumb-link",
};

export default selectors;
